/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import appConfig from 'src/appConfig';
import { Button, Text, View } from 'src/components/common';
import ComfirmationCodeField from 'src/components/ComfirmationCodeField';
import Loading from 'src/components/Loading';
import { modalActions } from 'src/redux/modalRedux';
import { IAppState } from 'src/store';
import { ApiError } from 'src/services/error';

export type EmailConfirmationModalData = {
  type?: 'email' | 'phoneNumber';
  value?: string;
  skipRequest?: boolean;
  onResend?: (...args: any) => void;
  onSubmit?: (...args: any) => void;
  onSuccess?: (...args: any) => void;
};
const EmailConfirmationModal: React.FC<Props> = ({ modalData, onCloseModal }) => {
  const { value, onSuccess, onResend, onSubmit } = modalData as EmailConfirmationModalData;

  const [code, setCode] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleValueChange = (value: string) => {
    setCode(value);
  };

  // =============================== Verify code ===============================
  useEffect(() => {
    if (code.length === appConfig.VERIFICATION_CODE_LENGTH) {
      handleSubmitCode(code);
    }
  }, [code]);

  const handleSubmitCode = (code: string) => {
    setIsSubmitting(true);
    onSubmit && onSubmit(code, submitSuccess, submitError);
  };

  const submitSuccess = (response: { id: string }) => {
    setIsSubmitting(false);
    onSuccess && onSuccess(response.id);
    onCloseModal();
  };

  const submitError = (error: ApiError) => {
    setIsSubmitting(false);
    setErrorMessage(error.message);
  };

  // =============================== Verify code ===============================
  const handleSendAgain = () => {
    setIsResending(true);
    onResend && onResend(resendCallback, resendCallback);
  };

  const resendCallback = () => {
    setIsResending(false);
  };

  return (
    <View className={cn('ctn-modal__content', { 'ctn-modal__loading': isSubmitting })}>
      <Loading visible={isSubmitting} variant="primary" position="absolute" />

      <h3 className="mb-1">{'Verification Code'}</h3>
      <Text>Please enter the verification code sent to {value}</Text>

      <View className={cn('my-24')}>
        <ComfirmationCodeField onChange={handleValueChange} errorMessage={errorMessage} />
      </View>

      <Text className={cn('mb-8')}>{"Didn't receive the code?"}</Text>

      <View isRow justify="center">
        <Button label={'Send Again'} onClick={handleSendAgain} isLoading={isResending} />
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & {};

const mapStateToProps = (state: IAppState) => ({
  modalData: state.modal.data,
});

const mapDispatchToProps = {
  onCloseModal: modalActions.closeModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailConfirmationModal);
